import axios from "axios"
export const baseUrl = "https://devbackend.pixamo.ai/api/v1"

axios.defaults.baseURL = baseUrl

export const nonAuthAxios = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
})

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${localStorage.getItem("pixamo_token")}`,
      "Accept-Language": `${localStorage.getItem("i18nextLng")}`,
    }

    return config
  },
  error => {
    return Promise.reject(error.message)
  }
)

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response?.data?.message) {
      return Promise.reject(error.response?.data?.message)
    } else if (error?.response?.status === 403) {
      return Promise.reject("you are not allowed to login")
    } else {
      return Promise.reject(error.message)
    }
  }
)

// Add a response interceptor for nonAuthAxios
nonAuthAxios.interceptors.response.use(
  response => {
    console.log(response)
    return response.data
  },
  error => {
    if (error.response?.data?.message) {
      return Promise.reject(error.response?.data?.message)
    } else {
      return Promise.reject(error.message)
    }
  }
)
